<div class="zoomWrapper">
  <a class="button zoomInc" (click)="zoomIncrease()">+</a>
  <a class="button zoomDec" (click)="zoomDecrease()">-</a>
</div>
<!-- <div class="_3dcontrol enable" [class.active]="threeDmode" (click)="toggleThreeDMode()"></div> -->
<div
  class="basemapSelector generic-tooltip right"
  [class.open]="basemapSelectorOpen"
  [attr.data-tooltip]="'Basemaps' | translate"
>
  <div
    class="toggleBtn"
    (click)="toggleBasemapSelector()"
    (appClickOutside)="basemapSelectorOpen = false"
  >
    <img
      *ngIf="currentBasemap"
      src="/assets/img/icons/basemap_{{ currentBasemap.id }}.png"
    />
  </div>
  <div class="container">
    <ul>
      <li
        *ngFor="let item of basemapList"
        (click)="changeBasemap(item)"
        [class.visible]="item.active"
      >
        <img src="/assets/img/icons/basemap_{{ item.id }}.png" />
        <span class="name">{{ item.label }}</span>
        <span *ngIf="item.visible" class="counter"></span>
        <span class="visibilityToggle"></span>
      </li>
    </ul>
    <h3>{{ 'Basemaps' | translate }}</h3>
  </div>
</div>
